import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/app/layouts/error.vue").then(m => m.default || m)),
  local: defineAsyncComponent(() => import("/app/layouts/local.vue").then(m => m.default || m))
}